import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Responsible from 'evcharging/components/Responsible';
import book from 'evcharging/assets/ev-charger/book.png';
import Box from 'evcharging/components/Box';
import Title from 'evcharging/components/Title';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import Desktop from 'evcharging/components/Desktop';
import Mobile from 'evcharging/components/Mobile';
import userFriendly from 'evcharging/assets/ev-charger/userFriendly.png';
import useI18n from 'evcharging/hooks/useI18n';
import Image from 'next/image';

const UserFriendly = () => {
  const { t } = useI18n();

  return (
    <Section
      backgroundSize={'cover'}
      backgroundColor={'#f6f8f9'}
      backgroundImage={`url(${userFriendly})`}
      backgroundPosition={'center'}
    >
      <Container position={'relative'}>
        <Desktop>
          <Box position={'absolute'} top={-130}>
            <Image
              src={book}
              alt={t('charger.friendly.alt')}
              title={t('charger.friendly.alt')}
              width={523}
              height={300}
            />
          </Box>
        </Desktop>
        <Mobile>
          <Image src={book} alt={t('charger.friendly.alt')} width={523} height={300} />
          <Spacer value={50} />
        </Mobile>
        <Responsible fractions={[50, 50]}>
          <Desktop>
            <span />
          </Desktop>
          <Box>
            <Title variant={'h2'}>{t('charger.friendly.title')}</Title>
            <Spacer value={20} />
            <Paragraph color={'middle'}>{t('charger.friendly.body')}</Paragraph>
          </Box>
        </Responsible>
      </Container>
    </Section>
  );
};

export default UserFriendly;
